(function( $ ) {
    $(".news-item-switcher").each(function() {
        const $mainImage = $(".homepage-latest-news .image");
        const $mainTitle = $(".homepage-latest-news .news-item-data h3");
        const $mainExcerpt = $(".homepage-latest-news .news-item-data p");
        const $mainLink = $(".homepage-latest-news .news-item-data .links #post-permalink");

        $(this).slick({
            rows: 0,
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 5000
        });

        $(this).on('afterChange', function (event, slick, currentSlide, nextSlide) {
            var $slides = slick.$slides;
            // console.log("Current Slide: " + currentSlide)
            var id = $slides.eq(currentSlide).get(0).id;
            var $title = $("#" + id).children("span.title").text();
            var $excerpt = $("#" + id).children("span.excerpt").text();
            var $link = $("#" + id).children("span.link").text();
            var $background = $("#" + id).children("span.background").text();


            $mainTitle.text($title);
            $mainExcerpt.text($excerpt);
            $mainLink.attr("href", $link);
            $mainImage.css("background-image", 'url('+$background+')');
            // $("#" + id).addClass('active');
        });

    })



    $(".news-item-selector").on("click", function () {
        var slideno = $(this).data('slick-index');
        $('.news-item-switcher').slick('slickGoTo', slideno);
    });
})(jQuery);